import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import Plus from "rialto-icons/Plus";

import Checkbox from "components/Checkbox";

import Avatar from "../Avatar";

import styles from "./DropdownItem.css";

const DropdownItem = ({ isMultiple, isSelected, value }) => {
  const itemClass = classnames(styles.item, {
    [styles.selected]: isSelected,
  });

  const { icon, label, sublabel, user } = value;

  const lbl = user ? (
    <div className={styles.label}>
      {user.fname} {user.lname}
    </div>
  ) : (
    <div className={styles.label}>{label}</div>
  );

  const sublbl = sublabel ? <div className={styles.sublabel}>{sublabel}</div> : null;

  const Icon = icon;

  const plusDimensions = {
    height: ".75rem",
    width: ".75rem",
  };

  const addonLeft = icon ? ( // eslint-disable-line
    <div className={styles.addonLeft}>
      <Icon dimensions={icon === Plus ? plusDimensions : undefined} />
    </div>
  ) : user ? (
    <div className={styles.addonLeft}>
      <Avatar fname={user.fname} lname={user.lname} size="small" src={user.profilePictureUrl} />
    </div>
  ) : null;

  return (
    <div>
      <button className={itemClass} type="button">
        {isMultiple && <Checkbox isChecked={isSelected} />}
        {addonLeft}
        <div className={styles.labelWrapper}>
          {sublbl}
          {lbl}
        </div>
      </button>
    </div>
  );
};

DropdownItem.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      icon: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
      user: PropTypes.shape({
        fname: PropTypes.string,
        lname: PropTypes.string,
        profilePictureUrl: PropTypes.string,
      }),
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      sublabel: PropTypes.string,
      onClick: PropTypes.func,
    }),
  ]),
  isMultiple: PropTypes.bool,
  isSelected: PropTypes.bool,
};

export default DropdownItem;
